import _get from 'lodash/get'
import request from '../request'
import { createAuthorization } from '../auth'

/**
 * Get user tag options from Brooklyn
 */
export async function _getUserTagOptions ({ auth, server }) {
  const res = await request
    .get(`${server}/v1/user-tags/admin/options`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

/**
 * Post user tag option to Brooklyn
 */
export async function _postUserTagOption ({
  auth, server, tag, category, translations,
}) {
  const res = await request
    .post(`${server}/v1/user-tags/admin/options`)
    .send({ tag, category, translations })
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

/**
 * Update existing user tag option in Brooklyn
 */
export async function _putUserTagOption ({
  auth, server, id, tag, category,
}) {
  const res = await request
    .put(`${server}/v1/user-tags/admin/options/${id}`)
    .send({ tag, category })
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

/**
 * Delete user tag option from Brooklyn
 */
export async function _deleteUserTagOption ({ auth, server, id }) {
  const res = await request
    .delete(`${server}/v1/user-tags/admin/options/${id}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

/**
 * Post user tag option translation to Brooklyn
 */
export async function _postUserTagOptionTranslation ({
  auth, server, userTagsOptionsId, code, value,
}) {
  const res = await request
    .post(`${server}/v1/user-tags/admin/translations/${userTagsOptionsId}`)
    .send({ translations: [{ code, value }] })
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

/**
 * Update existing user tag translation in Brooklyn
 */
export async function _putUserTagTranslation ({
  auth, server, id, code, value,
}) {
  const res = await request
    .put(`${server}/v1/user-tags/admin/translations/${id}`)
    .send({ code, value })
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

/**
 * Delete user tag translation from Brooklyn
 */
export async function _deleteUserTagTranslation ({ auth, server, id }) {
  const res = await request
    .delete(`${server}/v1/user-tags/admin/translations/${id}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}
